import React from "react";
import Settings from "../../components/settings/Settings";

const SettingsScreen = () => {
    return <Settings />;
};

export default SettingsScreen;
